import { DEFAULT_TEXT_STYLE } from './constants';

/** 构建地图文字标注 DOM */
export function buildTextLabelElement(feature, { selected = false, onSelect } = {}) {
  const el = document.createElement('div');
  el.className = `zhxt-draw-text-label${selected ? ' is-selected' : ''}`;
  el.dataset.featureId = feature.id;
  const style = el.style;
  style.fontFamily = feature.fontFamily || DEFAULT_TEXT_STYLE.fontFamily;
  style.fontSize = `${feature.fontSize || DEFAULT_TEXT_STYLE.fontSize}px`;
  style.letterSpacing = `${feature.letterSpacing ?? 0}px`;
  style.lineHeight = String(feature.lineHeight ?? DEFAULT_TEXT_STYLE.lineHeight);
  style.color = feature.color || DEFAULT_TEXT_STYLE.color;
  style.opacity = String(feature.opacity ?? DEFAULT_TEXT_STYLE.opacity);
  if (feature.bgEnabled !== false) {
    style.background = feature.bgColor || DEFAULT_TEXT_STYLE.bgColor;
    style.padding = '4px 8px';
    style.borderRadius = '4px';
    style.boxShadow = '0 1px 4px rgba(0,0,0,0.18)';
  } else {
    style.background = 'transparent';
    style.padding = '2px 0';
    style.boxShadow = 'none';
  }
  style.whiteSpace = 'pre-wrap';
  style.maxWidth = '280px';
  style.cursor = 'grab';
  style.userSelect = 'none';
  style.pointerEvents = 'auto';
  style.border = selected ? '1px solid #0f766e' : '1px solid transparent';
  el.textContent = feature.text || '文字';
  el.addEventListener('click', (ev) => {
    ev.stopPropagation();
    onSelect?.(feature.id);
  });
  el.addEventListener('dblclick', (ev) => {
    ev.stopPropagation();
    onSelect?.(feature.id, { edit: true });
  });
  return el;
}
